// FETCH ALL PRODUCT DETAILS
export const FETCH_PRODUCT_DETAILS_REQUEST = 'FETCH_PRODUCT_DETAILS_REQUEST';
export const FETCH_PRODUCT_DETAILS_SUCCESS = 'FETCH_PRODUCT_DETAILS_SUCCESS';
export const FETCH_PRODUCT_DETAILS_FAILURE = 'FETCH_PRODUCT_DETAILS_FAILURE';

// FETCH ALL PRODUCT DETAILS BY ID
export const FETCH_PRODUCT_DETAILS_BY_ID_REQUEST = 'FETCH_PRODUCT_DETAILS_BY_ID_REQUEST';
export const FETCH_PRODUCT_DETAILS_BY_ID_SUCCESS = 'FETCH_PRODUCT_DETAILS_BY_ID_SUCCESS';
export const FETCH_PRODUCT_DETAILS_BY_ID_FAILURE = 'FETCH_PRODUCT_DETAILS_BY_ID_FAILURE';

// CREATE PRODUCT DETAILS
export const CREATE_PRODUCT_DETAILS_REQUEST = 'CREATE_PRODUCT_DETAILS_REQUEST';
export const CREATE_PRODUCT_DETAILS_SUCCESS = 'CREATE_PRODUCT_DETAILS_SUCCESS';
export const CREATE_PRODUCT_DETAILS_FAILURE = 'CREATE_PRODUCT_DETAILS_FAILURE';

// UPDATE PRODUCT DETAILS
export const UPDATE_PRODUCT_DETAILS_REQUEST = 'UPDATE_PRODUCT_DETAILS_REQUEST';
export const UPDATE_PRODUCT_DETAILS_SUCCESS = 'UPDATE_PRODUCT_DETAILS_SUCCESS';
export const UPDATE_PRODUCT_DETAILS_FAILURE = 'UPDATE_PRODUCT_DETAILS_FAILURE';

// FETCH SINGLE STATE OF PRODUCT DETAILS
export const FETCH_SINGLE_PRODUCT_DETAILS_REQUEST = 'FETCH_SINGLE_PRODUCT_DETAILS_REQUEST';
export const FETCH_SINGLE_PRODUCT_DETAILS_SUCCESS = 'FETCH_SINGLE_PRODUCT_DETAILS_SUCCESS';
export const FETCH_SINGLE_PRODUCT_DETAILS_FAILURE = 'FETCH_SINGLE_PRODUCT_DETAILS_FAILURE';

// DELETE PRODUCT DETAILS
export const DELETE_PRODUCT_DETAILS_REQUEST = 'DELETE_PRODUCT_DETAILS_REQUEST';
export const DELETE_PRODUCT_DETAILS_SUCCESS = 'DELETE_PRODUCT_DETAILS_SUCCESS';
export const DELETE_PRODUCT_DETAILS_FAILURE = 'DELETE_PRODUCT_DETAILS_FAILURE';

// FETCH ALL PRODUCT TYPE FROM PROPERTY
export const FETCH_PRODUCT_DATA_FROM_PROPERTY_REQUEST = 'FETCH_PRODUCT_DATA_FROM_PROPERTY_REQUEST';
export const FETCH_PRODUCT_DATA_FROM_PROPERTY_SUCCESS = 'FETCH_PRODUCT_DATA_FROM_PROPERTY_SUCCESS';
export const FETCH_PRODUCT_DATA_FROM_PROPERTY_FAILURE = 'FETCH_PRODUCT_DATA_FROM_PROPERTY_FAILURE';

export const RESET_PRODUCT_DETAILS_INFO = 'RESET_PRODUCT_DETAILS_INFO';

export const CREATE_PRODUCT_DETAILS_FORM = 'CREATE_PRODUCT_DETAILS_FORM';

export const UPDATE_PRODUCT_DETAILS_FORM = 'UPDATE_PRODUCT_DETAILS_FORM';
